var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getNow, updateDate } from 'src/shared/helpers/dateHelpers';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { E_GENDER, } from 'src/services/cases/types';
export var checkValidModalIdentitiesValues = function (i18n, identities) {
    return identities.map(function (identity) {
        var _a = identity || {}, birthDate = _a.birthDate, birthName = _a.birthName, birthPlace = _a.birthPlace, familyName = _a.familyName, givenName = _a.givenName, givenName2 = _a.givenName2, givenName3 = _a.givenName3, honorificPrefix = _a.honorificPrefix, identityDocument = _a.identityDocument;
        var _b = identityDocument || {}, documentNumber = _b.documentNumber, expirationDate = _b.expirationDate, mrzLines = _b.mrzLines;
        var daysInMonth = birthDate ? updateDate(getNow(), { month: birthDate.month, year: birthDate.year }).daysInMonth : 0;
        var expirationDaysInMonth = expirationDate
            ? updateDate(getNow(), { month: expirationDate.month, year: expirationDate.year }).daysInMonth
            : 0;
        var isBirthDateDayError = !!birthDate && birthDate.day > daysInMonth;
        var isBirthDateYearError = !!birthDate && birthDate.year < 1900;
        var isBirthNameError = !!birthName && birthName.length > 100;
        var isBirthPlaceError = !!birthPlace && birthPlace.length > 100;
        var isFamilyNameError = !!familyName && familyName.length > 100;
        var isGivenNameError = !!givenName && givenName.length > 100;
        var isGivenName2Error = !!givenName2 && givenName2.length > 100;
        var isGivenName3Error = !!givenName3 && givenName3.length > 100;
        var isHonorificPrefixError = !!honorificPrefix && honorificPrefix.length > 100;
        var isDocumentNumberError = !!documentNumber && documentNumber.length > 100;
        var isExpirationDateDayError = !!expirationDate && expirationDate.day > expirationDaysInMonth;
        var isExpirationDateYearError = !!expirationDate && expirationDate.year < 1900;
        return __assign({ applicantId: identity.applicantId, birthDateDay: {
                isError: isBirthDateDayError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.invalidDay'),
            }, birthDateYear: {
                isError: isBirthDateYearError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.invalidYear'),
            }, birthName: {
                isError: isBirthNameError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            }, birthPlace: {
                isError: isBirthPlaceError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            }, familyName: {
                isError: isFamilyNameError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            }, givenName: {
                isError: isGivenNameError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            }, givenName2: {
                isError: isGivenName2Error,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            }, givenName3: {
                isError: isGivenName3Error,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            }, honorificPrefix: {
                isError: isHonorificPrefixError,
                infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
            } }, (identityDocument
            ? {
                identityDocument: {
                    documentNumber: {
                        isError: isDocumentNumberError,
                        infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
                    },
                    expirationDateDay: {
                        isError: isExpirationDateDayError,
                        infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.invalidDay'),
                    },
                    expirationDateYear: {
                        isError: isExpirationDateYearError,
                        infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.invalidYear'),
                    },
                    mrzLines: mrzLines.map(function (mrzLine) { return ({
                        isError: !!mrzLine && mrzLine.length > 100,
                        infoMessage: getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.identityValidation.inputErrors.tooLong'),
                    }); }),
                },
            }
            : undefined));
    });
};
export var getApplicantFullName = function (applicant) {
    return "".concat((applicant === null || applicant === void 0 ? void 0 : applicant.firstName) || '').concat((applicant === null || applicant === void 0 ? void 0 : applicant.lastName) ? " ".concat(applicant.lastName) : '');
};
export var getIdentity = function (identities, applicant) {
    return identities.find(function (identity) { return identity.applicantId === (applicant === null || applicant === void 0 ? void 0 : applicant.id); });
};
export var getGenderValue = function (i18n, genderLabel) {
    if (!genderLabel) {
        return null;
    }
    var maleLabel = getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.genderOptions.male");
    if (genderLabel === maleLabel) {
        return E_GENDER.MALE;
    }
    var femaleLabel = getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.genderOptions.female");
    if (genderLabel === femaleLabel) {
        return E_GENDER.FEMALE;
    }
    return E_GENDER.OTHER;
};
export var putUpdatedMrzIntoIdentity = function (identities, updatedDocumentData) {
    if (!updatedDocumentData) {
        return identities;
    }
    return identities.map(function (identity) {
        var mrzUpdated = updatedDocumentData === null || updatedDocumentData === void 0 ? void 0 : updatedDocumentData.mrz;
        return __assign(__assign({}, identity), (identity.identityDocument !== undefined
            ? {
                identityDocument: __assign(__assign({}, identity.identityDocument), (identity.identityDocument.mrzLines !== undefined
                    ? {
                        mrzLines: [
                            (mrzUpdated === null || mrzUpdated === void 0 ? void 0 : mrzUpdated.mrzLine1) || identity.identityDocument.mrzLines[0],
                            (mrzUpdated === null || mrzUpdated === void 0 ? void 0 : mrzUpdated.mrzLine2) || identity.identityDocument.mrzLines[1],
                            (mrzUpdated === null || mrzUpdated === void 0 ? void 0 : mrzUpdated.mrzLine3) || identity.identityDocument.mrzLines[2],
                        ],
                    }
                    : undefined)),
            }
            : undefined));
    });
};
